/** Returns the relevant extra filters for the chart query.
 * In most cases, we only need to send the navigation filter as query params to get the chart data.
 * However, in case the chart is viewed in explore, if its request is being updated and if the dashboard filters are disabled, we need to send all the extra filters.
 * @param {QueryFilterT | undefined} navigationFilter - The navigation filter are used to dig a chart
 * @param {QueryFilterT[]} allExtraFilters - The extra filters are used to dig a chart. It contains dashbboard and navigation filters.
 * @param {boolean} disableDashboardFilters - The disableDashboardFilters is used to disable dashboard filters.
 * @param {boolean} isViewedOnDashboard - The isViewedOnDashboard is used to check if the chart is viewed on dashboard.
 * @param {boolean} isBackendSync - The isBackendSync is used to check if the chart is synced with backend.
 */
export const getQueryExtraFilters = (
    navigationFilter: QueryFilterT | undefined,
    allExtraFilters: QueryFilterT[],
    disableDashboardFilters: boolean,
    isViewedOnDashboard: boolean,
    isBackendSync: boolean,
) => {
    if (!isViewedOnDashboard && !isBackendSync && !disableDashboardFilters) {
        return allExtraFilters;
    }
    return navigationFilter ? [navigationFilter] : [];
};
